const NOME_DIVERGENTE_MARKER = 'não corresponde ao nome do';
// TODO: trocar o casamento por substring na prosa do backend por códigos de erro
// (item 9 de documentation/plans/redesign-importacao-massa-2026-07/plan.md).
const DOCUMENTO_MARKERS = ['cpf', 'cnpj'];

function isErroNomeDivergente(erro: string): boolean {
  return erro.toLowerCase().includes(NOME_DIVERGENTE_MARKER);
}

export function isCpfCnpjInconsistencia(erros?: string[] | null): boolean {
  if (!erros?.length) return false;
  return erros.some(isErroNomeDivergente);
}

export function temErroDeDocumento(erros?: string[] | null): boolean {
  if (!erros?.length) return false;
  return erros.some((erro) => {
    if (isErroNomeDivergente(erro)) return false;
    const normalizado = erro.toLowerCase();
    return DOCUMENTO_MARKERS.some((marker) => normalizado.includes(marker));
  });
}

export function tituloInconsistenciaReceita(issueCount: number): string {
  return issueCount === 1
    ? '1 CPF/CNPJ com inconsistência na Receita Federal'
    : `${issueCount} CPFs/CNPJs com inconsistências na Receita Federal`;
}

export function deveAbrirModalInconsistencia(
  issueCount: number,
  loteId: string | null,
  ultimoLoteAberto: string | null,
): boolean {
  return issueCount > 0 && loteId !== null && loteId !== ultimoLoteAberto;
}

export function subtituloInconsistenciaReceita(
  issueCount: number,
  totalCount: number,
  contagemDoLoteInteiro: boolean,
): string {
  if (!contagemDoLoteInteiro) {
    return `${issueCount} com nome divergente. Você pode corrigir automaticamente, prosseguir sem essas linhas ou revisar manualmente.`;
  }

  const denominador = Math.max(totalCount, issueCount);
  const sujeito =
    issueCount === 1
      ? `1 de ${denominador} está divergente`
      : `${issueCount} de ${denominador} estão divergentes`;

  return `${sujeito}. Você pode corrigir automaticamente, prosseguir sem essas linhas ou revisar manualmente.`;
}

function normalizarNomeParaComparacao(nome: string): string {
  return nome
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
}

export function nomesConferem(nomePlanilha: string, nomeReceita: string): boolean {
  if (!nomePlanilha.trim() || !nomeReceita.trim()) return false;
  return normalizarNomeParaComparacao(nomePlanilha) === normalizarNomeParaComparacao(nomeReceita);
}

export function helperNomeReceita(nomePlanilha: string, nomeReceita: string): string {
  if (nomesConferem(nomePlanilha, nomeReceita)) {
    return 'Nome na planilha igual ao da Receita';
  }

  const origem = nomePlanilha.trim()
    ? `Nome na planilha: ${nomePlanilha.trim()}`
    : 'A planilha não informou nome';

  return `${origem} | Nome na Receita: ${nomeReceita}`;
}

export function acaoCorrigirNomes(issueCount: number): string {
  return issueCount === 1 ? 'Corrigir nome automaticamente' : 'Corrigir nomes automaticamente';
}

export function tituloCorrecaoNomes(itensCorrigidos: number): string {
  if (itensCorrigidos === 0) return 'Nenhum nome foi corrigido';
  return itensCorrigidos === 1 ? '1 nome corrigido' : `${itensCorrigidos} nomes corrigidos`;
}

export function descricaoCorrecaoNomes(itensCorrigidos: number, itensSemNomeApi: number): string {
  const confirmacao = 'Os nomes foram atualizados com o dado oficial da Receita Federal.';

  if (itensSemNomeApi === 0) {
    return itensCorrigidos === 0 ? 'Nenhum nome divergente foi encontrado no lote.' : confirmacao;
  }

  const semNome =
    itensSemNomeApi === 1
      ? '1 linha não pôde ser corrigida porque a Receita Federal não tem nome para o documento.'
      : `${itensSemNomeApi} linhas não puderam ser corrigidas porque a Receita Federal não tem nome para o documento.`;

  return itensCorrigidos === 0 ? semNome : `${confirmacao} ${semNome}`;
}

export function descricaoProsseguirSemLinhas(issueCount: number): string {
  return issueCount === 1
    ? 'Mantém a linha no lote para revisão, mas não a envia'
    : `Mantém as ${issueCount} linhas no lote para revisão, mas não as envia`;
}
